export default __webpack_public_path__ + "static/media/expand-collapse-pink-16px.518f2282.svg";